import FloatingLabelSelect from './FloatingLabelSelect';

export default FloatingLabelSelect;



// WEBPACK FOOTER //
// ./src/components/common/FloatingLabelSelect/index.js